import { Box, Card, Grid, Icon, IconButton, InputLabel, Skeleton, Switch, Tab, Table, TableRow, Tabs } from "@mui/material";
import TableBody from '@mui/material/TableBody';
import MDBox from "components/MDBox";
import MDSelect from "components/MDSelect";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import { useUser } from "context/UserContext";
import DataTableBodyCell from "examples/Tables/DataTable/DataTableBodyCell";
import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";
import { Form, Formik, useFormikContext } from "formik";
import FormField from "layouts/pages/users/new-user/components/FormField";
import PropTypes from "prop-types";
import { useEffect, useState } from 'react';
import { errorAlert, formatarParaMoeda, verifyVariable } from "utils/Functions";
import { get } from "utils/WebService";
import LawyersCreateEdit from "../lawyers/LawyersCreateEdit";
import { ESCURO } from "assets/coresTema";

export default function ProcessCreateEdit({ processId, closeCreateEdit, refreshTable }) {
    const {
        numeroProcesso,
        status,
        instancia,
        valorCausa,
        tipoPessoa,
        sentenca } = configForm.formField;

    const { processoPessoaTipo, processoStatus } = useUser();

    const [isLoadingInfo, setIsLoadingInfo] = useState(false);
    const [lawyers, setLawyers] = useState([]);
    const [instancias, setIntancias] = useState([]);
    const [pessoas, setPessoas] = useState([]);
    const [tabValue, setTabValue] = useState(1);
    const [idInstancia, setIdInstancia] = useState(null);
    const [createEditLawyer, setCreateEditLawyer] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    useEffect(() => {
        handleSearchLawyers(null, null, null);
        handleSearchPessoa(null, null, null);
    }, []);

    function handleSearchLawyers(value, id, type) {
        if (id != null && type != null) {
            let searchAdvogado = verifyVariable(value) ? `search=${value}` : "";
            let searchIdInstancia = verifyVariable(id) ? `idInstancia=${id}` : "";
            let searchType = verifyVariable(type) ? `type=${type}` : "";
            let queryParams = [searchAdvogado, searchIdInstancia, searchType].filter(param => param).join("&");

            get(`/instances/list-process-advogados${queryParams ? `?${queryParams}` : ""}`)
                .then(({ list }) => {
                    setLawyers(list);
                }).catch(() => {
                    setLawyers([]);
                });
        } else {
            let search = verifyVariable(value) ? `?search=${value}` : "";
            get(`/lawyer/list-all${search}`)
                .then(({ list }) => {
                    setLawyers(list);
                }).catch(() => {
                    setLawyers([]);
                });
        }

    }

    function handleSearchPessoa(value, id, type) {
        if (id != null && type != null) {
            let searchPessoa = verifyVariable(value) ? `search=${value}` : "";
            let searchIdInstancia = verifyVariable(id) ? `idInstancia=${id}` : "";
            let searchType = verifyVariable(type) ? `type=${type}` : "";
            let queryParams = [searchPessoa, searchIdInstancia, searchType].filter(param => param).join("&");

            get(`/instances/list-process-pessoas${queryParams ? `?${queryParams}` : ""}`)
                .then(({ list }) => {
                    setPessoas(list);
                }).catch(() => {
                    setPessoas([]);
                });
        } else {
            let search = verifyVariable(value) ? `?search=${value}` : "";
            get(`/processes/pessoas/list-all${search}`)
                .then(({ list }) => {
                    setPessoas(list);
                }).catch(() => {
                    setPessoas([]);
                });
        }
    }

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const backFunction = () => {
        setCreateEditLawyer(false);
        setSelectedId(null)
    }

    const editLawyer = (id) => {
        setCreateEditLawyer(true);
        setSelectedId(id)
    }

    const handleSubmit = (values, actions) => {
        // TODO: Implementar envio do form
        actions.setSubmitting(false);
    };

    return (
        <>
            <Grid container display="flex" justifyContent="center">
                {createEditLawyer &&
                    <Grid item xs={12} md={12}>
                        <LawyersCreateEdit
                            lawyerId={selectedId}
                            closeCreateEdit={backFunction} />
                    </Grid>
                }
            </Grid>

            <Card id="user-info" sx={{ display: createEditLawyer ? "none" : "" }}>
                <Box display="flex" alignItems="center" p={3}>
                    <IconButton onClick={closeCreateEdit} sx={{ p: 0, paddingRight: 1, paddingTop: 0.75 }}>
                        <MDTypography variant="h5">
                            <Icon>arrow_back</Icon>
                        </MDTypography>
                    </IconButton>
                    <MDTypography variant="h6">Detalhes do Processo</MDTypography>
                </Box>
                <Formik
                    initialValues={{
                        id: null,
                        numeroProcesso: '',
                        status: null,
                        instancia: null,
                        valorCausa: '',
                        tipoPessoa: null,
                        sentenca: null,
                        advogados: null,
                        nomes: null,
                        analisado: false,
                        processFaseRows: null
                    }}
                    onSubmit={(values, actions) => {
                        actions.setSubmitting(true);
                        handleSubmit(values, actions);
                    }}>
                    {({ values, errors, touched, isSubmitting, setFieldValue }) => {
                        const changeValorCausa = (instancia) => {
                            setFieldValue('valorCausa', formatarParaMoeda(instancia?.valor))
                            setFieldValue('processFaseRows', instancia?.processoFase)
                        }

                        return (
                            <Form id={configForm.formId} autoComplete="off">
                                <FetchAndSetData
                                    processId={processId}
                                    setIsLoadingInfo={setIsLoadingInfo}
                                    closeCreateEdit={closeCreateEdit}
                                    setIntancias={setIntancias}
                                    setIdInstancia={setIdInstancia}
                                    changeValorCausa={changeValorCausa} />

                                <MDBox px={3}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={3}>
                                            <FormField
                                                disabled={true}
                                                loading={isLoadingInfo}
                                                type={numeroProcesso.type}
                                                label={numeroProcesso.label}
                                                name={numeroProcesso.name}
                                                value={values.numeroProcesso ?? ""}
                                                placeholder={numeroProcesso.placeholder}
                                                style={{
                                                    backgroundColor: darkMode ? `${ESCURO.hover} !important` : undefined,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <FormField
                                                disabled={true}
                                                loading={isLoadingInfo}
                                                type={status.type}
                                                label={status.label}
                                                name={status.name}
                                                value={values.status ?? ""}
                                                placeholder={status.placeholder}
                                                style={{
                                                    backgroundColor: darkMode ? `${ESCURO.hover} !important` : undefined,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Instâncias</InputLabel>
                                            <MDSelect
                                                isLoading={isLoadingInfo}
                                                isMulti={false}
                                                getOptionValue={option => option.id}
                                                getOptionLabel={option => option.instancia}
                                                name="instancia-select"
                                                placeholder={instancia.placeholder}
                                                value={values.instancia}
                                                options={instancias}
                                                onChange={selectedOptions => {
                                                    setIdInstancia(selectedOptions.id)
                                                    changeValorCausa(selectedOptions)
                                                    setFieldValue("instancia", selectedOptions);
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <FormField
                                                disabled={true}
                                                loading={isLoadingInfo}
                                                type={valorCausa.type}
                                                label={valorCausa.label}
                                                name={valorCausa.name}
                                                value={values.valorCausa ?? ""}
                                                placeholder={valorCausa.placeholder}
                                                style={{
                                                    backgroundColor: darkMode ? `${ESCURO.hover} !important` : undefined,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Tipo Pessoa</InputLabel>
                                            <MDSelect
                                                isLoading={isLoadingInfo}
                                                isMulti={false}
                                                getOptionValue={option => option.code}
                                                getOptionLabel={option => option.name}
                                                name="tipoPessoa-select"
                                                placeholder={tipoPessoa.placeholder}
                                                value={values.tipoPessoa}
                                                options={processoPessoaTipo}
                                                onChange={selectedOptions => {
                                                    handleSearchPessoa(null, idInstancia, selectedOptions.id)
                                                    handleSearchLawyers(null, idInstancia, selectedOptions.id)
                                                    setFieldValue("tipoPessoa", selectedOptions);
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <FormField
                                                disabled={true}
                                                loading={isLoadingInfo}
                                                type={sentenca.type}
                                                label={sentenca.label}
                                                name={sentenca.name}
                                                value={values.sentenca ?? ""}
                                                placeholder={sentenca.placeholder}
                                                style={{
                                                    backgroundColor: darkMode ? `${ESCURO.hover} !important` : undefined,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={2} display="flex" justifyContent="center" alignItems="center">
                                            {isLoadingInfo ? <Skeleton width={"80%"} sx={{ mt: 2 }} /> :
                                                <Box display="flex" justifyContent="start" alignItems="center" lineHeight={1} mt={2}>
                                                    <MDTypography variant="button" sx={{ fontSize: '10px' }}>
                                                        Analisado
                                                    </MDTypography>
                                                    <Box ml={1}>
                                                        <Switch disabled={true} checked={values.analisado || false} onChange={(event) => setFieldValue('analisado', event.target.checked)} />
                                                    </Box>
                                                </Box>
                                            }
                                        </Grid>
                                    </Grid>

                                    <MDBox sx={{ width: '100%', px: 2, mt: 5, mb: 8 }}>

                                        <MDBox sx={{ borderBottom: 1, width: "100%", borderColor: 'divider' }}>
                                            <Tabs value={tabValue} onChange={handleChange} aria-label="enterprises-system-tabs">
                                                <Tab label="Fases" value={1} sx={{ fontSize: 12 }} />
                                                <Tab label="Advogados" value={2} sx={{ fontSize: 12 }} />
                                                <Tab label="Nomes" value={3} sx={{ fontSize: 12 }} />
                                            </Tabs>
                                        </MDBox>

                                        <div
                                            role="tabpanel"
                                            hidden={tabValue !== 1}
                                            id={`fase-${1}`}
                                            aria-labelledby={`fase-${1}`}>
                                            {tabValue === 1 &&
                                                <ProcessoFaseTable
                                                    rows={values.processFaseRows}
                                                />
                                            }
                                        </div>
                                        <div
                                            role="tabpanel"
                                            hidden={tabValue !== 2}
                                            id={`advogados-${2}`}
                                            aria-labelledby={`advogados-${2}`}>
                                            {tabValue === 2 &&
                                                <ListBoxTable
                                                    rows={lawyers}
                                                    isLawyer={true}
                                                    editLawyer={editLawyer}
                                                />}
                                        </div>
                                        <div
                                            role="tabpanel"
                                            hidden={tabValue !== 3}
                                            id={`nomes-${3}`}
                                            aria-labelledby={`nomes-${3}`}>
                                            {tabValue === 3 &&
                                                <ListBoxTable
                                                    rows={pessoas}
                                                    isLawyer={false}
                                                />}
                                        </div>
                                    </MDBox>
                                </MDBox>

                            </Form>)
                    }}
                </Formik>
            </Card >
        </>

    );
};

const FetchAndSetData = ({ processId, setIsLoadingInfo, closeCreateEdit, setIntancias, setIdInstancia, changeValorCausa }) => {
    const { setFieldValue } = useFormikContext();
    const { processoStatus } = useUser();

    useEffect(() => {
        if (processId) {
            setIsLoadingInfo(true);
            get(`/processes/by-id/${processId}`).then(data => {
                const { id,
                    numeroProcesso,
                    status,
                    instancias,
                    valorCausa,
                    tipoPessoa,
                    sentenca,
                    advogados,
                    nomes,
                    analisado } = data;
                setFieldValue('id', id);
                setFieldValue('numeroProcesso', numeroProcesso);
                setFieldValue('status', processoStatus.find(ht => ht.code === status)?.name);
                setFieldValue('valorCausa', valorCausa);
                setFieldValue('tipoPessoa', tipoPessoa);
                setFieldValue('sentenca', sentenca);
                setFieldValue('nomes', nomes);
                setFieldValue('advogados', advogados);
                setFieldValue('analisado', analisado);
                setIntancias(instancias)
                setIsLoadingInfo(false);

                if (instancias && instancias.length > 0) {
                    setIdInstancia(instancias[0].id)
                    changeValorCausa(instancias[0])
                    setFieldValue("instancia", instancias[0]);
                }
            }).catch(() => errorAlert("Processo não encontrado!", closeCreateEdit));
        }


    }, [processId]);

    return null;
};

export const configForm = {
    formId: "configuration-form",
    formField: {
        numeroProcesso: {
            name: "numeroProcesso",
            label: "Nº Processo",
            type: "text",
            placeholder: "Informe o nº do processo...",
            errorMsg: "Campo Obrigatório. Somente espaços em brancos não são permitidos.",
        },
        status: {
            type: "text",
            name: "status",
            label: "Status",
        },
        instancia: {
            name: "instancia",
            label: "Instância",
            placeholder: "Seleciona a instância",
        },
        subsessao: {
            name: "subsessao",
            label: "Subsessão",
            type: "text",
            placeholder: "Informe o subsessao...",
        },
        valorCausa: {
            name: "valorCausa",
            label: "Valor Causa",
            type: "text",
            placeholder: "Informe o valor da causa...",
        },
        tipoPessoa: {
            name: "tipoPessoa",
            label: "Tipo Pessoa",
            placeholder: "Selecione o tipo pessoa",
        },
        sentenca: {
            type: "text",
            name: "sentenca",
            label: "Sentença",
        },
        advogados: {
            name: "advogados",
            label: "Advogados",
            placeholder: "Lista dos advogado",
        },
        nomes: {
            name: "nomes",
            label: "Nomes",
            placeholder: "Lista dos nomes"
        }
    }
}

ProcessCreateEdit.propTypes = {
    lawyerId: PropTypes.string,
    closeCreateEdit: PropTypes.func.isRequired,
};

const processColumn = [
    { name: "Nome" },
    { name: "Vara" },
    { name: "Data Andamento" },
    { name: "Tipo Andamento" },
]

const pessoasColumn = [
    { name: "Nome" }
]

const advogadosColumn = [
    { name: "Nome" }
]

function ProcessoFaseTable({ rows }) {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    return (
        <MDBox sx={{ maxHeight: "400px", overflowY: "auto" }}>
            <Table stickyHeader>
                <MDBox component="thead" >
                    <TableRow>
                        {processColumn?.map((cols, idx) =>
                            <DataTableHeadCell
                                key={idx}
                                width={"auto"}
                                align={cols.align}
                                sorted={false}>
                                {cols.name || "N/A"}
                            </DataTableHeadCell>
                        )}
                    </TableRow>
                </MDBox>
                <TableBody>
                    {rows?.map((row, key) => {
                        return (
                            <TableRow key={key}>
                                <DataTableBodyCell isProcess={true}>
                                    <MDTypography variant="caption" fontWeight="regular" color="text">
                                        {row.nome || "N/A"}
                                    </MDTypography>
                                </DataTableBodyCell>
                                <DataTableBodyCell isProcess={true}>
                                    <MDTypography variant="caption" fontWeight="regular" color="text">
                                        {row.vara || "N/A"}
                                    </MDTypography>
                                </DataTableBodyCell>
                                <DataTableBodyCell isProcess={true}>
                                    <MDTypography variant="caption" fontWeight="regular" color="text">
                                        {row.data || "N/A"}
                                    </MDTypography>
                                </DataTableBodyCell>
                                <DataTableBodyCell isProcess={true}>
                                    <MDTypography variant="caption" fontWeight="regular" color="text">
                                        {row.tipo || "N/A"}
                                    </MDTypography>
                                </DataTableBodyCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        </MDBox>
    );
}

function ListBoxTable({ rows, isLawyer, editLawyer }) {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    return (
        <MDBox sx={{ maxHeight: "400px", overflowY: "auto" }}>
            <Table stickyHeader>
                <MDBox component="thead" >
                    <TableRow>
                        {(isLawyer ? advogadosColumn : pessoasColumn)?.map((cols, idx) =>
                            <DataTableHeadCell
                                key={idx}
                                width={"auto"}
                                align={cols.align}
                                sorted={false}>
                                {cols.name || "N/A"}
                            </DataTableHeadCell>
                        )}
                        {isLawyer &&
                            <DataTableHeadCell
                                width={"auto"}
                                align="center"
                                sorted={false}>
                                Editar
                            </DataTableHeadCell>}
                    </TableRow>
                </MDBox>
                <TableBody>
                    {rows?.map((row, key) => {
                        return (
                            <TableRow key={key}>
                                <DataTableBodyCell isProcess={true}>
                                    <MDTypography variant="caption" fontWeight="medium" color="text">
                                        {row.nome || "N/A"}
                                    </MDTypography>
                                </DataTableBodyCell>
                                {
                                    isLawyer &&
                                    <DataTableBodyCell align="center" isProcess={true}>
                                        <IconButton
                                            aria-label="edit"
                                            color="info"
                                            size="small"
                                            onClick={() => editLawyer(row.id)}
                                            sx={{ p: 0.5 }}
                                        >
                                            <Icon fontSize="small">edit</Icon>
                                        </IconButton>
                                    </DataTableBodyCell>
                                }
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        </MDBox>
    );
}
